export default "__VITE_ASSET__$K0v7XOq__"